export default __webpack_public_path__ + "static/media/gnosis-safe-multisig-logo.6baa9880.svg";